/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import cs from './cs.json';
import en from './en.json';
import sk from './sk.json';
// import de from './de.json';
// import fr from './fr.json';

// FOR TRANSLATION USE https://simpleen.io/app/#/translate/json
let messages = {
    cs,
    en,
    sk,
    // de, // NEEDS REVISION
    // fr, // NEEDS REVISION
};

Vue.use(VueI18n);

export default new VueI18n({
    locale: 'cs', // default locale
    messages,
});
